export const PRODUCT_SEARCH_FILTERS = [
  { key: 'rahmen', label: 'Spannrahmen', articleIds: [1] },
  { key: 'drehtueren', label: 'Drehtüren', articleIds: [2, 3] },
  { key: 'schiebetueren', label: 'Schiebetüren', articleIds: [4, 5, 7, 8, 10, 11] },
  { key: 'stulptueren', label: 'Stulptüren', articleIds: [13, 14] },
  { key: 'zargentueren', label: 'Zargentüren', articleIds: [15] },
  { key: 'pendeltueren', label: 'Pendeltüren', articleIds: [16] },
  { key: 'fenster_rollo', label: 'Rollo', articleIds: [17, 18] },
  { key: 'lisa', label: 'LISA', articleIds: [21, 22, 23, 24] },
  { key: 'p20_tueren', label: 'Plissee P20', articleIds: [25, 29, 30] },
  { key: 'p45', label: 'Plissee P45', articleIds: [26, 27, 28] },
];
